class TokenService {
  getLocalRefreshToken() {
    const tokens = JSON.parse(localStorage.getItem("cabtifyTokens"));
    return tokens?.refresh.token;
  }

  getLocalAccessToken() {
    const tokens = JSON.parse(localStorage.getItem("cabtifyTokens"));
    return tokens?.access.token;
  }

  updateLocalAccessToken(token) {
    let tokens = JSON.parse(localStorage.getItem("cabtifyTokens"));
    tokens.access = token;
    localStorage.setItem("cabtifyTokens", JSON.stringify(tokens));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("cabtifyTokens"));
  }
}

export default new TokenService();
